import React from 'react';
import { Popup as PopupGL } from 'react-mapbox-gl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PopupPoiInfo, { PopupTitle } from './PopupPoiInfo';
import device from '../../constants/device';

const PopupStyles = styled(PopupGL)`
    opacity: ${props => (props.active ? '1' : '0')};
    transition: opacity 600ms;

    .mapboxgl-popup-tip {
        display: none;
    }

    .mapboxgl-popup-content {
        padding: ${props => (props.small ? '10px 20px' : '0')};
        overflow: hidden;
        display: flex;
        width: ${props => (props.small ? 'auto' : '376px')};
        max-width: 100%;
        min-height: ${props => (props.small ? 'auto' : '120px')};
        box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.6);
        transform: translateY(${props => (props.active ? '0' : '25px')}) scale(${props => (props.active ? '1' : '.8')});
        transition: all 300ms;
        will-change: transform;
    }

    @media ${device.mobile} {
        opacity: 1;
        transform: none !important;
        top: auto;
        bottom: ${props => (props.active ? '0' : '-180px')};
        left: 0;
        right: 0;
        transition: bottom 600ms;
        .mapboxgl-popup-content {
            border-bottom: 1px solid ${props => props.theme.colors.lighttaupe};
            border-radius: 0 !important;
            width: 100%;
            transform: none;
        }
    }
`;

const Popup = ({ active, small, poi, onClick, anchor, offset, urlText }) => (
    <PopupStyles
        active={active}
        small={small}
        coordinates={[poi.coordinates.longitude, poi.coordinates.latitude]}
        anchor={anchor}
        offset={offset}
        onClick={onClick}
    >
        {small && <PopupTitle small>{poi.name}</PopupTitle>}
        {!small && <PopupPoiInfo info={poi} urlText={urlText} />}
    </PopupStyles>
);

Popup.defaultProps = {
    anchor: 'bottom',
    offset: {
        bottom: [0, -65],
    },
};

Popup.propTypes = {
    active: PropTypes.bool,
    small: PropTypes.bool,
    urlText: PropTypes.string.isRequired,
    poi: PropTypes.shape({
        name: PropTypes.string.isRequired,
        coordinates: PropTypes.shape({
            latitude: PropTypes.number.isRequired,
            longitude: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
    anchor: PropTypes.oneOf([
        'center',
        'top',
        'bottom',
        'left',
        'right',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right',
    ]),
    offset: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
};

export default Popup;
